import React from "react";
import "../styles/Infos.css";

// Les boutons pour ouvrir les documents dans la section info

function DocButtonsHome({ name, link }) {
  return (
    <a
      className="buttonLink"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      <button className="docButtonHome">{name}</button>
    </a>
  );
}

export default DocButtonsHome;
